import { Div } from '@pinpoint/design-kit';
import React from 'react';
import PropTypes from 'prop-types';
import { YearDetailProp } from 'src/store/typings';
import { formatNumberV2, formatPercent } from 'src/functions';

/**
 * Year Impact
 * @param {{ year: 1|2|3, crnt: YearDetail, ss: YearDetail, wP: YearDetail }} props
 * @return {object}
 */
export default function YearImpact({ year, crnt, ss, wP }) {
  return (
    <Div
      d="grid"
      gridArea={`2 / ${year * 4} / -1 / ${year * 4 + 3}`}
      gridTplC="repeat(3, 1fr)"
      gridTplR="2rem 3rem repeat(2, 2rem) 1fr"
      gridGap="calc(1rem/16)"
    >
      <Div
        d="flex"
        p={{ r: '.75rem' }}
        align="center"
        justify="center"
        gridArea="1 / 1 / 2 / -1"
        bg="shadeEF"
        rounded="sm"
      >
        YEAR {year}
      </Div>
      <Div
        p={{ r: '.75rem' }}
        d="flex"
        align="center"
        justify="right"
        gridArea="2 / 1 / 3 / 2"
        bg="skyBlue"
        rounded="sm"
        textColor="white"
        textAlign="right"
      >
        Without
        <br />
        Pinpoint
      </Div>
      <Div
        d="flex"
        p={{ r: '.75rem' }}
        align="center"
        justify="right"
        gridArea="3 / 1 / 4 / 2"
        bg="skyBluePale2"
        rounded="sm"
        textWeight="400"
        whiteSpace="nowrap"
      >
        {formatPercent(ss.sumPolicies ? crnt.totalLR * 100 : 0, false)}
      </Div>
      <Div
        d="flex"
        p={{ r: '.75rem' }}
        align="center"
        justify="right"
        gridArea="4 / 1 / 5 / 2"
        bg="skyBluePale2"
        rounded="sm"
        textWeight="400"
        whiteSpace="nowrap"
      >
        ${formatNumberV2(ss.sumNet, true, true) ?? 0}
      </Div>
      <Div
        d="flex"
        p={{ r: '.75rem' }}
        align="center"
        justify="right"
        gridArea="2 / 2 / 3 / 3"
        bg="tealLight"
        rounded="sm"
        textColor="white"
        textAlign="right"
      >
        With
        <br />
        Pinpoint
      </Div>
      <Div
        d="flex"
        p={{ r: '.75rem' }}
        align="center"
        justify="right"
        gridArea="3 / 2 / 4 / 3"
        bg="powderGreenPale2"
        rounded="sm"
        textWeight="400"
        whiteSpace="nowrap"
      >
        {formatPercent(ss.sumPolicies ? wP.totalLR * 100 : 0, false)}
      </Div>
      <Div
        d="flex"
        p={{ r: '.75rem' }}
        align="center"
        justify="right"
        gridArea="4 / 2 / 5 / 3"
        bg="powderGreenPale2"
        rounded="sm"
        textWeight="400"
        whiteSpace="nowrap"
      >
        ${formatNumberV2(wP.sumNet, true, true) ?? 0}
      </Div>
      <Div
        d="flex"
        p={{ r: '.75rem' }}
        align="center"
        justify="right"
        gridArea="2 / 3 / 3 / 4"
        bg="tealLight"
        rounded="sm"
        textColor="white"
        textAlign="right"
      >
        Expected
        <br />
        Impact
      </Div>
      <Div
        d="flex"
        p={{ r: '.75rem' }}
        align="center"
        justify="right"
        gridArea="3 / 3 / 4 / 4"
        bg="powderGreenPale2"
        rounded="sm"
        whiteSpace="nowrap"
      >
        {formatPercent(ss.sumPolicies ? (wP.totalLR - crnt.totalLR) * 100 : 0, false)}
      </Div>
      <Div
        d="flex"
        p={{ r: '.75rem' }}
        align="center"
        justify="right"
        gridArea="4 / 3 / 5 / 4"
        bg="powderGreenPale2"
        rounded="sm"
        whiteSpace="nowrap"
      >
        ${formatNumberV2(wP.sumNet - ss.sumNet, true, true) ?? 0}
      </Div>
    </Div>
  );
}
YearImpact.defaultProps = {
  year: 1,
};

YearImpact.propTypes = {
  year: PropTypes.number,
  crnt: YearDetailProp.isRequired,
  ss: YearDetailProp.isRequired,
  wP: YearDetailProp.isRequired,
};
